module.exports = __webpack_public_path__ + "img/how-to-flow-l-02.dc141ee7.svg";